import PropTypes from 'prop-types';
import React from 'react';
import compose from 'recompose/compose';
import renderNothing from 'recompose/renderNothing';
import branch from 'recompose/branch';
import { connect } from 'react-redux';
import get from 'lodash.get';
import ExtraUserInformationFormModal from './ExtraUserInformationFormModal';
import styles from './ExtraUserInformation.css';
import SpartanAdditionalInformationFields from './SpartanAdditionalInformationFields';
import SPARTAN_USER_TYPES from '../../../constants/spartan-user-types';

const SpartanExtraInformation = ({ spartanUserType, ...props }) => (<ExtraUserInformationFormModal
    title="Welcome to Spartan College of Aeronautics and Technology!"
    subtitle="Please provide some additional information below to continue."
    {...props}
>
    <SpartanAdditionalInformationFields spartanUserType={spartanUserType} />
    <p className={styles.info}>
        {'Submission of this form indicates your permission for Spartan College of Aeronautics and Technology and its affiliates to contact you by phone (including mobile), email, text and/or other means. You also understand that these calls may be generated using an automated dialing technology.'}
    </p>
</ExtraUserInformationFormModal>);

SpartanExtraInformation.propTypes = {
    spartanUserType: PropTypes.number,
};

const showModal = ({ me, auth }) => {
    if (!me) {
        return false;
    }
    if (me.spartanUserType === SPARTAN_USER_TYPES.ON_CAMPUS_VISIT) {
        return false;
    }
    if (auth.level !== 5) {
        return false;
    }
    const required = ['graduationYear'];

    if (me.spartanUserType === SPARTAN_USER_TYPES.HIGH_SCHOOL) {
        required.push('advisorId', 'highSchoolId');
    }

    return required.some(key => !me[key]);
};

export default compose(
    connect(({ me, auth }) => ({
        show: showModal({ me, auth }),
        spartanUserType: get(me, 'spartanUserType'),
        initialValues: {
            mobilePhone: get(me, 'mobilePhone'),
            graduationYear: get(me, 'graduationYear'),
            advisorId: get(me, 'advisorId'),
            highSchoolId: get(me, 'highSchoolId'),
        },
    })),
    branch(
        ({ show }) => !show,
        renderNothing,
    ),
)(SpartanExtraInformation);



// WEBPACK FOOTER //
// ./src/client/Components/ExtraUserInformation/SpartanExtraInformation.js